import { Directive, OnDestroy } from '@angular/core';
import { Observable, Subject, MonoTypeOperatorFunction } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { throwAsyncError } from 'webcommon/shared/errors-ng1520';

// This is an interface to expose an Observable that emits when the implementing class is destroyed
// eslint-disable-next-line functional/type-declaration-immutability -- this is a special case of not wanting to mess with types that could be used with ported code from webcommon
export interface Destroyable$ {
  onDestroy$: Observable<void>;
}

// This can contain stuff shared across classes for services, components, etc
@Directive()
export class ApBaseClass implements OnDestroy, Destroyable$ {
  readonly onDestroy$: Subject<void> = new Subject<void>();

  throwAsyncError(error: unknown): void {
    throwAsyncError(error);
  }

  takeUntilDestroy<T>(): MonoTypeOperatorFunction<T> {
    return (source: Observable<T>): Observable<T> => {
      return source.pipe(takeUntil(this.onDestroy$));
    };
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
